import {
  CheckCircleFilled,
  CloseCircleFilled,
  ExclamationCircleFilled,
  InfoCircleFilled,
  MinusCircleFilled,
} from '@ant-design/icons';
import { statusIntent, type StatusIntent } from '@/theme/tokens';

const INTENT_VAR: Record<StatusIntent, string> = {
  positive: 'var(--ol-positive)',
  attention: 'var(--ol-attention)',
  negative: 'var(--ol-negative)',
  info: 'var(--ol-info)',
  neutral: 'var(--ol-text-tertiary)',
};

function IntentIcon({ intent }: { intent: StatusIntent }) {
  switch (intent) {
    case 'positive':
      return <CheckCircleFilled />;
    case 'negative':
      return <CloseCircleFilled />;
    case 'attention':
      return <ExclamationCircleFilled />;
    case 'neutral':
      return <MinusCircleFilled />;
    case 'info':
    default:
      return <InfoCircleFilled />;
  }
}

/**
 * A status token rendered with BOTH colour and an icon — colour is never the sole signal (spec §14).
 * The raw token renders verbatim (CORPUS-07: no synonym invention); the title carries it canonically.
 */
export function StatusPill({ status, size = 'sm' }: { status: string; size?: 'sm' | 'xs' }) {
  const intent = statusIntent(status);
  const color = INTENT_VAR[intent];
  return (
    <span
      className="ol-edge-pill"
      title={status}
      style={{
        color,
        fontSize: size === 'xs' ? 9.5 : 10,
      }}
    >
      <IntentIcon intent={intent} />
      {status}
    </span>
  );
}
